module.exports = __webpack_public_path__ + "static/img/cross.81371ab9.svg";